import Vue from 'vue'
import VueResource from 'vue-resource';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import List from './components/List.vue';
import DownloadItem from './components/DownloadItem.vue';
import router from './router';
import {subStrFilter,nvl} from './filters/comm'

Vue.use(ElementUI)
Vue.use(VueResource);
Vue.component('Header', Header);
Vue.use(Header);
Vue.component('Footer', Footer);
Vue.use(Footer);
Vue.component('List', List);
Vue.use(List);
Vue.component('DownloadItem', DownloadItem);
Vue.use(DownloadItem);
Vue.config.productionTip = false;

//注册全局过滤器
Vue.filter('subStrFilter',subStrFilter);
Vue.filter('nvl',nvl);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
